import { Container, Stack } from "@mui/material";
import { type PropsWithChildren } from "react";
import Banner from "../common/Banner";

interface Props {
  showBanner?: boolean;
}

const WidgetsPageContainer = ({ showBanner, children }: PropsWithChildren<Props>) => {
  return (
    <>
      {showBanner && <Banner />}
      <Container maxWidth="xl" disableGutters sx={{ pb: 1, pt: 2, px: 5, flex: 1, minHeight: 0 }}>
        <Stack spacing={2} sx={{ height: "100%", minHeight: 0 }}>
          {children}
        </Stack>
      </Container>
    </>
  );
};

export default WidgetsPageContainer;
